import React, { Component } from 'react'
import "../../css/FormSolicitud.css";
import logo from "../../assets/logo_espol_interno.svg";
import check from "../../assets/check.svg";
import anuncio from "../../assets/AnuncioICO.svg";
import equis from "../../assets/eliminar.svg"
import info from "../../assets/Info.png"
import Modal from './Modal';
import axios from "axios";
import { Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useState } from 'react';
import Header from '../components/Header.js'
import Footer from '../components/Footer.js'
import Acuerdo from './Acuerdo.js'

export default class FormSolicitud extends Component {


    constructor(props) {
        super(props);

        this.state = {
            verAcuerdo: false,
            usuarios_sugeridos_temp:[],
            alias_sugeridos_temp:[],
            solicitud: {
                identificacion: "",
                nombres: "",
                apellidos: "",
                telefono: "",
                actividad: "",
                unidad: "",
                correo: "",
                usuario_sugerido: "",
                alias_sugerido: "",
                terminos: false,
                estado: "No Revisado",
                idAcueFirmElec:"",
            },
            actividad: ["Est.Grado", "Est.PostGrado", "Gdo.PostGrado", "Gdo.Grado", "Prof.Grado", "Prof.PostGrado", "Investigador", "Administrativo"],
            modalIsOpen: false,
            modalAlias: false,
            showRenderLogin: false,
            modalVerificar: {
                show: false,
                titulo: "",
                mensaje: "",
                imagen: ""
            },
            expresiones: {
                /*nombres: /^[A-Za-zÑñÁáÉéÍíÓóÚúÜü\s]+$/, */ //Permite que se agreguen espacios al final
                nombres: /^[A-Za-zÑñÁáÉéÍíÓóÚúÜü]+( [A-Za-zÑñÁáÉéÍíÓóÚúÜü]+)*$/,
                dos_nombres: /^[A-Za-zÑñÁáÉéÍíÓóÚúÜü]+(?:\s+[A-Za-zÑñÁáÉéÍíÓóÚúÜü]+)+$/,
                /*apellidos: /^[A-Za-zÑñÁáÉéÍíÓóÚúÜü\s]+$/, */ //Permite que se agreguen espacios al final
                apellidos: /^[A-Za-zÑñÁáÉéÍíÓóÚúÜü]+( [A-Za-zÑñÁáÉéÍíÓóÚúÜü]+)*$/,
                dos_apellidos: /^[A-Za-zÑñÁáÉéÍíÓóÚúÜü]+(?:\s+[A-Za-zÑñÁáÉéÍíÓóÚúÜü]+)+$/,
                //correoAlterno: /^(\w+[/./-]?){1,}@[a-z]+[/.]\w{2,}$/,
                correoAlterno: /^(\w+[/./-]?){1,}@[a-z]+[/.]\w{2,}([/.]\w{2,})?$/,
                telefono: /^[\d]{7,10}$/,
                cedula: /^[a-zA-Z0-9._]{4,14}$/,
                usuario_sugerido: /^[a-zA-Z]{8}$/,
                alias_sugerido: /^[a-z]+[/.][a-z]+$/,
                unidad: /^[A-Za-zÑñÁáÉéÍíÓóÚúÜü\s]+$/,
            },
            posible_alias: "",
            mensaje_error_alias: "",
            errorSolicitud: {
                identificacion: "",
                nombres: "",
                apellidos: "",
                telefono: "",
                unidad: "",
                correoAlterno: "",
                usuario_sugerido: "",
                alias_sugerido: ""
            },
            Motivo: "",
            modalSugerencia: {
                show: false,
                titulo: "Sugerencia de Alias",
                mensaje: "Los alias que te sugerimos utilizar es este:",
                imagen: info,
                listSug: [],
            },
            listSugerencia: [],
            listUnidad: [],
            SelectUnit: '',
            activebutton: true,
            boolAlias:false,


        };
        this.abrirModalInfo = this.abrirModalInfo.bind(this);
        this.cerrarModalInfo = this.cerrarModalInfo.bind(this);
        this.cerrarModalAlias= this.cerrarModalAlias.bind(this);
        this.abrirModalVerificar = this.abrirModalVerificar.bind(this);
        this.cerrarModalVerificar = this.cerrarModalVerificar.bind(this);

        this.abrirModalSugerencia = this.abrirModalSugerencia.bind(this);
        this.cerrarModalSugerencia = this.cerrarModalSugerencia.bind(this);

        this.handlerOnBlur = this.handlerOnBlur.bind(this);

        this.abrirAcuerdo = this.abrirAcuerdo.bind(this);

        this.activebuttonf = this.activebuttonf.bind(this);
        this.disabledbuttonf = this.disabledbuttonf.bind(this);

        //this.subirimagenUsuario = this.subirimagenUsuario.bind(this);
        //this.subirimagenContrato = this.subirimagenContrato.bind(this);
    }

    activebuttonf() {
        this.setState({ activebutton: true });
    }

    disabledbuttonf() {
        this.setState({ activebutton: false });

    }


    abrirAcuerdo() {
        this.setState({ verAcuerdo: true });
    }



    abrirModalSugerencia() {
        this.setState({
            modalSugerencia: {
                ...this.state.modalSugerencia,
                show: true
            }
        });
    }


    cerrarModalSugerencia() {
        this.setState({
            modalSugerencia: {
                titulo: "",
                mensaje: "",
                imagen: "",
                listSug: [],
                show: false
            }
        });
        //console.log("cerrar modal " + this.state.modalVerificar);
    }

    abrirModalVerificar() {
        this.setState({
            modalVerificar: {
                ...this.state.modalVerificar,
                show: true
            }
        });
    }

    cerrarModalVerificar() {
        this.setState({
            modalVerificar: {
                titulo: "",
                mensaje: "",
                imagen: "",
                show: false
            }
        });
        //console.log("cerrar modal " + this.state.modalVerificar);
    }


    abrirModalInfo() {
        this.setState({ modalIsOpen: true });
    }

    cerrarModalInfo() {
        this.setState({ modalIsOpen: false });
        this.setState({ showRenderLogin: true })
    }

    abrirModalAlias() {
        this.setState({ modalAlias: true });
    }

    cerrarModalAlias() {
        this.setState({ modalAlias: false });
    }

    showusers = async (e) => {
        let nombres = document.querySelector('[name="nombres"]').value;
        let apellidos = document.querySelector('[name="apellidos"]').value;
        let nombre1=nombres.split(" ")[0];
        let nombre2=nombres.split(" ")[1];
        let apellido1=apellidos.split(" ")[0];
        let apellido2=apellidos.split(" ")[1];
        if (nombres.length != 0 & apellidos.length != 0) {
            await axios.get(`${process.env.REACT_APP_API}api/Persona/usuarios/${nombres}/${apellidos}`)
                .then(r => {
                    //console.log(r.data);
                    this.setState({usuarios_sugeridos_temp: r.data});
                })
                .catch(error => {
                    //console.log(error.message);
                });

                await axios.get(`${process.env.REACT_APP_API}api/Persona/alias/${nombres}/${apellidos}`)
                .then(r => {
                    //console.log(r.data);
                    this.setState({alias_sugeridos_temp: r.data});
                })
                .catch(error => {
                    //console.log(error.message);
                });
        }
    }

    mayus(e) {
        e.target.value = e.target.value.toUpperCase();
    }


    handlerDatos = async (e) => {
        this.showusers();
        if(e.target.name=="apellidos" || e.target.name=="nombres"){
            await this.setState({
                solicitud: {
                    ...this.state.solicitud,
                    [e.target.name]: e.target.value.toUpperCase(),
                    //terminos:e.target.checked
                }
            })
        }else{
            //console.log(e.target.name);
            if(e.target.name=="alias_sugerido"){
                this.setState({boolAlias:true});
            }
            await this.setState({
                solicitud: {
                    ...this.state.solicitud,
                    [e.target.name]: e.target.value,
                    //terminos:e.target.checked
                }
            })
        }
        //console.log(this.state.solicitud);
        this.handlerOnBlur();
    }

    handlerTerminos = async (e) => {
        await this.setState({
            solicitud: {
                ...this.state.solicitud,
                terminos: e.target.checked
            }
        })
        //console.log(this.state.solicitud);
        this.handlerOnBlur();
    }

    handlerOnBlur = async () => {

        if (this.state.solicitud.identificacion === "") {
            await this.setState({
                errorSolicitud: {
                    ...this.state.errorSolicitud,
                    identificacion: "El campo 'Identificación' es requerido"
                }
            })
        } else if (!this.state.expresiones.cedula.test(this.state.solicitud.identificacion)) {
            await this.setState({
                errorSolicitud: {
                    ...this.state.errorSolicitud,
                    identificacion: "Identificación debe tener 10 dígitos"
                }
            })
        } else {
            this.setState({
                errorSolicitud: {
                    ...this.state.errorSolicitud,
                    identificacion: ""
                }
            })
        }

        if (this.state.solicitud.nombres === "") {
            await this.setState({
                errorSolicitud: {
                    ...this.state.errorSolicitud,
                    nombres: "El campo 'Nombres' es requerido"
                }
            })
        } else if (!this.state.expresiones.nombres.test(this.state.solicitud.nombres)) {
            await this.setState({
                errorSolicitud: {
                    ...this.state.errorSolicitud,
                    nombres: "El campo 'Nombres' solo acepta letras y espacio entre los nombres"
                }
            })
        } else {
            this.setState({
                errorSolicitud: {
                    ...this.state.errorSolicitud,
                    nombres: ""
                }
            })
        }


        if (this.state.solicitud.apellidos === "") {
            await this.setState({
                errorSolicitud: {
                    ...this.state.errorSolicitud,
                    apellidos: "El campo 'Apellidos' es requerido"
                }
            })
        } else if (!this.state.expresiones.apellidos.test(this.state.solicitud.apellidos)) {
            await this.setState({
                errorSolicitud: {
                    ...this.state.errorSolicitud,
                    apellidos: "El campo 'Apellidos' solo acepta letras y espacio entre los apellidos",
                }
            })
        } else {
            this.setState({
                errorSolicitud: {
                    ...this.state.errorSolicitud,
                    apellidos: ""
                }
            })
        }

        if (this.state.solicitud.telefono === "") {
            await this.setState({
                errorSolicitud: {
                    ...this.state.errorSolicitud,
                    telefono: "El campo 'Teléfono' es requerido"
                }
            })
        } else if (!this.state.expresiones.telefono.test(this.state.solicitud.telefono)) {
            await this.setState({
                errorSolicitud: {
                    ...this.state.errorSolicitud,
                    telefono: "El campo 'Teléfono' solo acepta números",
                }
            })
        } else {
            this.setState({
                errorSolicitud: {
                    ...this.state.errorSolicitud,
                    telefono: ""
                }
            })
        }

        //UNIDAD
        //console.log(this.state.solicitud.unidad);
        if (this.state.solicitud.unidad === "") {
            await this.setState({
                errorSolicitud: {
                    ...this.state.errorSolicitud,
                    unidad: "El campo 'Unidad' es requerido"
                }
            })
        } else if (!this.state.expresiones.unidad.test(this.state.solicitud.unidad)) {
            await this.setState({
                errorSolicitud: {
                    ...this.state.errorSolicitud,
                    unidad: "El campo 'Unidad' solo acepta letras",
                }
            })
        } else {
            this.setState({
                errorSolicitud: {
                    ...this.state.errorSolicitud,
                    unidad: ""
                }
            })
        }

        //CORREO ALTERNO
        if (this.state.solicitud.correo === "") {
            await this.setState({
                errorSolicitud: {
                    ...this.state.errorSolicitud,
                    correoAlterno: "El campo 'Correo alterno' es requerido"
                }
            })
        } else if (!this.state.expresiones.correoAlterno.test(this.state.solicitud.correo)) {
            await this.setState({
                errorSolicitud: {
                    ...this.state.errorSolicitud,
                    correoAlterno: "El campo 'Correo alterno' tiene formato incorrecto",
                }
            })
        } else {
            this.setState({
                errorSolicitud: {
                    ...this.state.errorSolicitud,
                    correoAlterno: ""
                }
            })
        }

        //USUARIO SUGERIDO ANTERIOR
        /*if (this.state.solicitud.usuario_sugerido === "") {
            await this.setState({
                errorSolicitud: {
                    ...this.state.errorSolicitud,
                    usuario_sugerido: "El campo 'Usuario sugerido' es requerido"
                }
            })
        } else if (!this.state.expresiones.usuario_sugerido.test(this.state.solicitud.usuario_sugerido)) {
            await this.setState({
                errorSolicitud: {
                    ...this.state.errorSolicitud,
                    usuario_sugerido: "Usuario debe tener 8 caractéres. El usuario debe estar compuesto por nombre y apellido.",
                }
            })
        } else {
            this.setState({
                errorSolicitud: {
                    ...this.state.errorSolicitud,
                    usuario_sugerido: ""
                }
            })
        }*/
        //console.log(this.state.solicitud.usuario_sugerido);
        if (this.state.solicitud.usuario_sugerido === "") {
            await this.setState({
                errorSolicitud: {
                    ...this.state.errorSolicitud,
                    usuario_sugerido: "El campo 'Usuario sugerido' es requerido"
                }
            })
        } else {
            this.setState({
                errorSolicitud: {
                    ...this.state.errorSolicitud,
                    usuario_sugerido: ""
                }
            })
        }

        //ALIAS SUGERIDO
        //console.log(this.state.solicitud.alias_sugerido);
        if (this.state.solicitud.alias_sugerido === "") {
            await this.setState({
                errorSolicitud: {
                    ...this.state.errorSolicitud,
                    alias_sugerido: "El campo 'Alias sugerido' es requerido"
                }
            });
            //MOSTRAR MODAL CON MENSAJE DE QUE EL CAMPO ALIAS.....
        } else if (!this.state.expresiones.alias_sugerido.test(this.state.solicitud.alias_sugerido)) {
            await this.setState({
                errorSolicitud: {
                    ...this.state.errorSolicitud,
                    alias_sugerido: "El campo 'Alias sugerido' solo acepta entradas de este tipo: nombre.apellido",
                }
            })
        } else {
            this.setState({
                errorSolicitud: {
                    ...this.state.errorSolicitud,
                    alias_sugerido: ""
                }
            });
            if(this.state.boolAlias){
                this.abrirModalAlias();
                this.setState({boolAlias:false});
            }
            
        }
        /*console.log("blur");
        console.log(this.state.errorSolicitud);*/
    }



    postVerificarSolicitud = async (e) => {
        e.preventDefault();
        this.disabledbuttonf();
        //this.abrirAcuerdo();
        var aliasExiste;
        var usuarioExiste;
        /*Hay que sobreescribir el estado en esta seccion*/
        /*var estado=this.state.solicitud.estado;*/
        var estado = "No Revisado";
        var infoSolicitud = this.state.solicitud;
        var solicitud = {
            estado: estado,
            Identificacion: this.state.solicitud.identificacion,
            infoSolicitud: JSON.stringify(infoSolicitud),
            Motivo: "Solicitud a espera de revisión"
        }

        var alias = this.state.solicitud.alias_sugerido;
        var username = this.state.solicitud.usuario_sugerido;
        var nombres = this.state.solicitud.nombres;
        var apellidos = this.state.solicitud.apellidos;
        //this.abrirModalInfo();
        await axios.get(`${process.env.REACT_APP_API}api/CuentaUsuario/verificaralias/${alias}/${nombres}/${apellidos}`)
            .then(r => {
                if (r.data.success) {
                    aliasExiste = true;
                    this.state.mensaje_error_alias = r.data.message;
                    if (r.data.message === "El alias ingresado no tiene relación con el nombre o el apellido" || r.data.message === "No se ha podido recomendar un alias. Revise que sus nombres y Apellidos esten completos") {
                        //console.log("existe alias");
                        this.state.listSugerencia = [];

                    } else if (r.data.message === "El alias que ingreso ya se encuentra siendo utilizado. Le sugerimos que utilice el siguientes alias:") {
                        this.state.listSugerencia = r.data.lSugerencia;
                    }

                }
                else {
                    //console.log("no existe alias");
                    aliasExiste = false;
                    //this.state.posible_alias = "" ;
                }
                this.activebuttonf();

            })
            .catch(error => {
                //console.log(error.message);
                this.setState({
                    modalVerificar: {
                        show: true,
                        titulo: "Error en la solicitud",
                        mensaje: "Error en la solicitud, intente mas tarde.",
                        imagen: equis
                    }
                })
                this.activebuttonf();
            })


        await axios.get(`${process.env.REACT_APP_API}api/CuentaUsuario/verificarusername/${username}/${nombres}/${apellidos}`)
            .then(r => {
                if (r.data.success) {
                    //console.log("existe username");
                    usuarioExiste = true;
                    this.state.listSugerencia = r.data.lSugerencia;
                }
                else {
                    //console.log("no existe username");
                    usuarioExiste = false;
                }
                this.activebuttonf();
            })
            .catch(error => {
                //this.setState({modalMensaje:"Error en la solicitud, intente mas tarde."})
                //this.abrirModalError();
                this.setState({
                    modalVerificar: {
                        show: true,
                        titulo: "Error en la solicitud",
                        mensaje: "Error en la solicitud, intente mas tarde.",
                        imagen: equis
                    }
                })
                this.activebuttonf();
                //console.log(error.message);
            })



        if (aliasExiste === false && usuarioExiste === false) {
            this.setState({
                solicitud: {
                    ...this.state.solicitud,
                    nombres: this.state.solicitud.nombres.toLowerCase(),
                    apellidos: this.state.solicitud.apellidos.toLowerCase(),

                }
            })
            this.abrirAcuerdo();
        } else if (aliasExiste && usuarioExiste) {
            this.setState({
                modalVerificar: {
                    show: true,
                    titulo: "Alias y usuario existen",
                    mensaje: "Alias y usuario existe por favor ingrese otro",
                    imagen: equis
                }
            })
        } else if (usuarioExiste) {
            this.setState({
                modalSugerencia: {
                    show: true,
                    titulo: "Sugerencia de Usuarios",
                    mensaje: "El usuario que ingreso ya se encuentra siendo utilizado. Le sugerimos que utilice uno del siguientes usuarios:",
                    imagen: info,
                    listSug: this.state.listSugerencia,
                }
            });
        } else if (aliasExiste) {
            this.setState({
                modalSugerencia: {
                    show: true,
                    titulo: "Sugerencia de alias",
                    mensaje: this.state.mensaje_error_alias,
                    imagen: info,
                    listSug: this.state.listSugerencia,
                }
            });
        }

    }

    componentDidMount() {
        this.setState({
            solicitud: {
                //identificacion: "0987456321"
                identificacion: Cookies.get("identificacion")

            }
        })
        axios.get(`${process.env.REACT_APP_API}api/Grupo`)
            .then(r => {
                //console.log(r.data);
                this.setState({ listUnidad: r.data });
            })
            .catch(error => {
               //console.log(error.message);
            })
    }



    render() {
        return (
            this.state.verAcuerdo ?
                <Acuerdo
                    identificacion={this.state.solicitud.identificacion}
                    nombres={this.state.solicitud.nombres.toLocaleLowerCase()}
                    apellidos={this.state.solicitud.apellidos.toLocaleLowerCase()}
                    usuario_sugerido={this.state.solicitud.usuario_sugerido}
                    infoSolicitud={JSON.stringify(this.state.solicitud)}
                    Motivo={"Solicitud a espera de revisión"}
                    estado={"No Revisado"}
                    tipoForm={"S"}
                    mensaje_titulo="CREAR CUENTA"
                    verbtngeneral={false}
                    verbtngeneralElectronica={true}
                    callTagManager={this.props.callTagManager}

                ></Acuerdo> :
                (<div>
                    <Header />
                    <div className="solicitud-container">
                        <div className="row">
                            <div >
                                <div className="col-12 ">
                                    <p className="nacionalidad-title"><b>CREAR CUENTA</b></p>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6 col-xl-3 mt-3">
                                <label id="texto" htmlFor="identificacion">Identificación: </label>
                                <input
                                    disabled
                                    className={this.state.errorSolicitud.identificacion ? "form-control solicitud-input-error" : "form-control solicitud-input"}
                                    type="text" name="identificacion"
                                    value={this.state.solicitud.identificacion}
                                    onChange={this.handlerDatos}
                                    onBlur={this.handlerOnBlur}
                                />
                                {this.state.errorSolicitud.identificacion &&
                                    <p className='solicitud-leyenda'>{this.state.errorSolicitud.identificacion}</p>
                                }
                            </div>
                            <div className="col-md-6 col-xl-3 mt-3">
                                <label id="texto" htmlFor="nombres">Nombres: </label>
                                <input
                                    className={this.state.errorSolicitud.nombres ? "form-control solicitud-input-error" : "form-control solicitud-input"}
                                    type="text"
                                    name="nombres"
                                    value={this.state.solicitud.nombres}
                                    onChange={this.handlerDatos}
                                    onBlur={this.handlerOnBlur}
                                   // onKeyUp={this.mayus}
                                />
                                {this.state.errorSolicitud.nombres &&
                                    <p className='solicitud-leyenda'>{this.state.errorSolicitud.nombres}</p>
                                }
                            </div>
                            <div className="col-md-6 col-xl-3 mt-3">
                                <label id="texto" htmlFor="apellidos">Apellidos: </label>
                                <input
                                    className={this.state.errorSolicitud.apellidos ? "form-control solicitud-input-error UpperCase" : "form-control solicitud-input UpperCase"}
                                    type="text"
                                    name="apellidos"
                                    value={this.state.solicitud.apellidos}
                                    onChange={this.handlerDatos} onBlur={this.handlerOnBlur}
                                    //onKeyUp={this.mayus}
                                />
                                {this.state.errorSolicitud.apellidos &&
                                    <p className='solicitud-leyenda'>{this.state.errorSolicitud.apellidos}</p>
                                }
                            </div>
                            <div className="col-md-6 col-xl-3 mt-3">
                                <label id="texto" htmlFor="telefono">Teléfono: </label>
                                <input
                                    className={this.state.errorSolicitud.telefono ? "form-control solicitud-input-error" : "form-control solicitud-input"}
                                    type="number"
                                    name="telefono"
                                    value={this.state.solicitud.telefono}
                                    onChange={this.handlerDatos}
                                    onBlur={this.handlerOnBlur}
                                />
                                {this.state.errorSolicitud.telefono &&
                                    <p className='solicitud-leyenda'>{this.state.errorSolicitud.telefono}</p>
                                }
                            </div>
                        </div>

                        <fieldset className="form-group ">
                            <div className="row mt-3">
                                <label id="solicitud-textoNegrita" className="col-form-label col-sm-2">Actividad: </label>
                            </div>
                            <div className="row solicitud-opactividad">
                                <div className="col-sm-12 solicitud-usuarios">
                                    {this.state.actividad.map((value, index) => {
                                        return (
                                            <div className="form-check" key={index}>
                                                <input className="form-check-input" type="radio" name="actividad" id="actividad" value={value} onClick={this.handlerDatos} />
                                                <label className="form-check-label" htmlFor="actividad">{value}</label>
                                            </div>
                                        );
                                    })}

                                </div>
                            </div>
                        </fieldset>
                        <div className="row mt-3">
                            <div className="col-md-6 col-xl-3 mt-3">
                                <label id="texto" htmlFor="unidad">Unidad a la que pertenece: </label>
                                <select onBlur={this.handlerOnBlur} onChange={this.handlerDatos} value={this.state.solicitud.unidad} name="unidad" className="form-control">
                                    <option key="" value="">Escoge una unidad</option>
                                    {this.state.listUnidad.map(elemento => (<option key={elemento.idsccegrupo} value={elemento.nombre} >{elemento.nombre}</option>))}

                                </select>


                                {/*{this.state.errorSolicitud.unidad &&*/}
                                {/*    <p className='solicitud-leyenda'>{this.state.errorSolicitud.unidad}</p>*/}
                                {/*}*/}
                            </div>

                            <div className="col-md-6 col-xl-3 mt-3" htmlFor="correo">
                                <label id="texto">Correo alterno: </label>
                                <input
                                    className={this.state.errorSolicitud.correoAlterno ? "form-control solicitud-input-error" : "form-control solicitud-input"}
                                    type="email"
                                    name="correo"
                                    value={this.state.solicitud.correo}
                                    onChange={this.handlerDatos}
                                    onBlur={this.handlerOnBlur}
                                />
                                {this.state.errorSolicitud.correoAlterno &&
                                    <p className='solicitud-leyenda'>{this.state.errorSolicitud.correoAlterno}</p>
                                }
                            </div>
                            <div className="col-md-6 col-xl-3 mt-3">
                                <label id="texto" htmlFor="usuario_sugerido">Usuario sugerido: </label>
                                {/*
                                <input
                                    className={this.state.errorSolicitud.usuario_sugerido ? "form-control solicitud-input-error" : "form-control solicitud-input"}
                                    type="text" name="usuario_sugerido"
                                    value={this.state.solicitud.usuario_sugerido}
                                    onChange={this.handlerDatos}
                                    onBlur={this.handlerOnBlur}
                                />
                                {this.state.errorSolicitud.usuario_sugerido &&
                                    <p className='solicitud-leyenda'>{this.state.errorSolicitud.usuario_sugerido}</p>
                                }
                                */}
                                
                                {/*<button
                                    type="submit"
                                    disabled={this.state.solicitud.nombres &&
                                        this.state.solicitud.apellidos
                                        ? false : true}
                                    className={this.state.solicitud.nombres &&
                                        this.state.solicitud.apellidos ?
                                        "solicitud-btn-submit" : "solicitud-btn-submit-disabled"}
                                    onClick={this.showusers}
                                >mostrar</button>
                                {this.state.usuarios_sugeridos_temp.map((value, index) => {
                                        return (
                                            <div className="form-check1" key={index}>
                                                <input className="form-check-input" type="radio" name="actividad" id="actividad" value={value} onClick={this.handlerDatos} />
                                                <label className="form-check-label" htmlFor="usuario_sugerido">{value}</label>
                                            </div>
                                        );
                                    })} 
                                */}
                                 <select onBlur={this.handlerOnBlur} onChange={this.handlerDatos} value={this.state.solicitud.usuario_sugerido} name="usuario_sugerido" className="form-control">
                                    <option key="" value="">Escoge un usuario</option>
                                    {this.state.usuarios_sugeridos_temp.map(elemento => (<option key={elemento} value={elemento} >{elemento}</option>))}
                                </select>
                                <p align="justify" className='solicitud-infor'>El campo "Usuario sugerido" es el identificador que deberá usar para acceder a los sistemas de la ESPOL.</p>

                            </div>
                            <div className="col-md-6 col-xl-3 mt-3">
                                <label id="texto" htmlFor="alias_sugerido">Alias sugerido: </label>
                                <div className="input-group">
                                    {/*<input
                                        type="text"
                                        className={this.state.errorSolicitud.alias_sugerido ? "form-control solicitud-input-error" : "form-control solicitud-input"}
                                        id="alias_sugerido"
                                        placeholder="Alias"
                                        name="alias_sugerido"
                                        value={this.state.solicitud.alias_sugerido}
                                        onChange={this.handlerDatos}
                                        onBlur={this.handlerOnBlur}
                                    />*/}
                                    <select onBlur={this.handlerOnBlur} onChange={this.handlerDatos} value={this.state.solicitud.alias_sugerido} name="alias_sugerido" className="form-control">
                                    <option key="" value="">Escoge un Alias</option>
                                    {this.state.alias_sugeridos_temp.map(elemento => (<option key={elemento} value={elemento} >{elemento}</option>))}

                                </select>
                                    <div className="input-group-prepend">
                                        <div id="texto" className="input-group-text">@espol.edu.ec</div>
                                    </div>
                                </div>
                                {this.state.errorSolicitud.alias_sugerido &&
                                    <p className='solicitud-leyenda'>{this.state.errorSolicitud.alias_sugerido}</p>
                                }
                                <p align="justify" className='solicitud-infor'>El campo "Alias sugerido" es un identificador adicional de la cuenta, disponible únicamente para el envío de correo.</p>

                            </div>
                            <p align="justify">
                                Soy responsable del uso de la cuenta electrónica de acuerdo a lo que estipula el reglamento de uso de cuentas electrónicas de la ESPOL publicado en el siguiente enlace:  
                                <a href="http://www.dspace.espol.edu.ec/xmlui/handle/123456789/40396">Reglamento Espol</a>
                            </p>

                            {/*<div className="form-check mb-2 ">*/}
                            {/*    <input*/}
                            {/*        className="form-check-input"*/}
                            {/*        type="checkbox"*/}
                            {/*        id="terminos"*/}
                            {/*        name="terminos"*/}
                            {/*        checked={this.state.solicitud.terminos}*/}
                            {/*        onChange={this.handlerTerminos} />*/}

                            {/*    <label className="form-check-label" htmlFor="terminos">*/}
                            {/*        Acepto los términos y condiciones anteriores*/}
                            {/*    </label>*/}
                            {/*</div>*/}


                            <div className="container-botonGuardar">
                                <button
                                    type="submit"
                                    disabled={this.state.solicitud.identificacion &&
                                        this.state.solicitud.nombres &&
                                        this.state.solicitud.apellidos &&
                                        this.state.solicitud.telefono &&
                                        this.state.solicitud.actividad &&
                                        this.state.solicitud.unidad &&
                                        this.state.solicitud.correo &&
                                        this.state.solicitud.usuario_sugerido &&
                                        this.state.solicitud.alias_sugerido &&
                                        !this.state.errorSolicitud.identificacion &&
                                        !this.state.errorSolicitud.nombres &&
                                        !this.state.errorSolicitud.apellidos &&
                                        !this.state.errorSolicitud.telefono &&
                                        !this.state.errorSolicitud.unidad &&
                                        !this.state.errorSolicitud.correoAlterno &&
                                        !this.state.errorSolicitud.usuario_sugerido &&
                                        !this.state.errorSolicitud.alias_sugerido &&
                                        this.state.activebutton
                                        ? false : true}
                                    className={this.state.solicitud.identificacion &&
                                        this.state.solicitud.nombres &&
                                        this.state.solicitud.apellidos &&
                                        this.state.solicitud.telefono &&
                                        this.state.solicitud.actividad &&
                                        this.state.solicitud.unidad &&
                                        this.state.solicitud.correo &&
                                        this.state.solicitud.usuario_sugerido &&
                                        this.state.solicitud.alias_sugerido &&
                                        !this.state.errorSolicitud.identificacion &&
                                        !this.state.errorSolicitud.nombres &&
                                        !this.state.errorSolicitud.apellidos &&
                                        !this.state.errorSolicitud.telefono &&
                                        !this.state.errorSolicitud.unidad &&
                                        !this.state.errorSolicitud.correoAlterno &&
                                        !this.state.errorSolicitud.usuario_sugerido &&
                                        !this.state.errorSolicitud.alias_sugerido &&
                                        this.state.activebutton ?
                                        "solicitud-btn-submit" : "solicitud-btn-submit-disabled"}
                                    onClick={this.postVerificarSolicitud}
                                >SIGUIENTE</button>
                                {!this.state.activebutton ?
                                    <span className="registroContra-fr-top spinner-border text-primary ms-2" role="status" aria-hidden="true"></span>
                                    : null}

                            </div>


                        </div>

                    </div>


                    <Footer />
                    {this.state.modalIsOpen &&
                        <Modal isOpen={this.state.modalIsOpen} cerrarModal={this.cerrarModalInfo} verBoton={true} textoBoton="ACEPTAR" >
                            <p className='text-center'><strong>Formulario enviado</strong></p>
                            <div className='mt-2 mb-2' align="center">
                                <img className="solicitud-check" src={check} alt="Exitoso"></img>
                            </div>

                            <p className='text-center'><strong>¡Gracias por finalizar el formulario!</strong></p>
                            <p className='text-center'>Personal de GTSI se comunicará pronto a tu correo alterno.</p>

                        </Modal>}
                        {this.state.modalAlias &&
                        <Modal isOpen={this.state.modalAlias} cerrarModal={this.cerrarModalAlias} verBoton={true} textoBoton="ACEPTAR" >
                            <p className='text-center'><strong>¡Recuerda!</strong></p>
                            <div className='mt-2 mb-2' align="center">
                                <img className="solicitud-check" src={anuncio} alt="Exitoso"></img>
                            </div>
                            <p className='text-center'>El Alias <strong>{this.state.solicitud.alias_sugerido}</strong> solo sirve para que otras personas puedan enviarte correos electrónicos.</p>

                        </Modal>}
                    {this.state.modalVerificar.show &&
                        <Modal isOpen={this.state.modalVerificar.show} cerrarModal={this.cerrarModalVerificar} verBoton={true} textoBoton="ACEPTAR" >
                            <p className='text-center'><strong>{this.state.modalVerificar.titulo}</strong></p>
                            <div className='mt-2 mb-2' align="center">
                                <img className="solicitud-check" src={this.state.modalVerificar.imagen} alt="Exitoso"></img>
                            </div>

                            <p className='text-center'>{this.state.modalVerificar.mensaje}</p>
                        </Modal>}

                    {this.state.modalSugerencia.show &&
                        <Modal isOpen={this.state.modalSugerencia.show} cerrarModal={this.cerrarModalSugerencia} verBoton={true} textoBoton="ACEPTAR" >
                            <p className='text-center'><strong>{this.state.modalSugerencia.titulo}</strong></p>
                            <div className='mt-2 mb-2' align="center">
                                <img className="solicitud-check" src={this.state.modalSugerencia.imagen} alt="Exitoso"></img>
                            </div>

                            <p className='text-center'>{this.state.modalSugerencia.mensaje}</p>
                            <div className="divCentrar">
                                <ul className='solicitud-menulist' >
                                    <b>{this.state.modalSugerencia.listSug.map((sugerencia) => <li>{sugerencia}</li>)}</b>
                                </ul>
                            </div>
                        </Modal>}


                </div>)
        )
    }
}
